// extracted by mini-css-extract-plugin
module.exports = {"root":"Detail_root__unKgl","titleWrapper":"Detail_titleWrapper___o1e5","title":"Detail_title__qENLt","value":"Detail_value__MqyQd"};